export const SET_AVATAR = 'SET_AVATAR';
export const setAvatar = (avatar: string) => {
  return {
    type: SET_AVATAR,
    avatar
  }
}